import moment from "moment";
export const spiltStringAndGetLastIndex = (data: any) => {
  let splitData = data?.toString()?.split("-");
  return splitData[splitData?.length - 1];
};

export const getFormattedDate = (date: any) => {
  try {
    const formattedDateTime = moment(date).format("DD MMM, YYYY, hh:mm A");
    return formattedDateTime;
  } catch (e) {
    return "invalid date format";
  }
};

export const scrollToTop = () => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth"
  });
};
